// Состояние лайтбокса поверх диалога. Отдельным хуком, потому что просмотр
// элемента открывается и самостоятельным диалогом, и панелью внутри пикера —
// оба места держат лайтбокс по одному рецепту (см. `ElementLightbox`).

import { useCallback, useState } from "react";

export interface ElementLightboxState {
    /** Индекс открытой картинки; `null` — лайтбокс закрыт. */
    index: number | null;
    isOpen: boolean;
    open: (index: number) => void;
    close: () => void;
}

export function useElementLightbox(): ElementLightboxState {
    const [index, setIndex] = useState<number | null>(null);
    const close = useCallback(() => setIndex(null), []);

    return { index, isOpen: index !== null, open: setIndex, close };
}
